var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card skeleton-card",style:({ minHeight: _vm.height })},[_c('div',{staticClass:"card-body",style:({ padding: _vm.padding })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }